import { createClient } from '@connectrpc/connect';
import { timestampDate } from '@bufbuild/protobuf/wkt';
import { EventService } from '@buf/motto_cda.bufbuild_es/motto/cda/cms/event/v1/service_pb';
import { cdaTransport, authHeaders } from './transport';

export interface EventData {
  id: string;
  title: string;
  description?: string;
  startTime: string;
  endTime?: string;
  posterUrl?: string;
  videoIds?: string[];
  error?: string;
}



export enum EventsSortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

const eventClient = createClient(EventService, cdaTransport);

export async function fetchEventData(
  publicKey: string,
  eventId: string,
  unused?: any,
  filter?: string,
  order?: EventsSortDirection,
  locale?: string
): Promise<EventData> {
  // filter/order are not part of GetEventRequest in the CDA schema; the old
  // fetch-based code sent them but the server ignored them.
  const response = await eventClient.getEvent(
    {
      eventId,
      ...(locale?.length ? { locale } : {}),
    },
    { headers: authHeaders(publicKey) }
  );

  const event = response.event;
  if (!event) {
    throw new Error('Failed to fetch event data: empty response');
  }

  return {
    id: event.id,
    title: event.title,
    description: event.description || undefined,
    startTime: event.startTime ? timestampDate(event.startTime).toISOString() : '',
    posterUrl: event.posterUrl || undefined,
    videoIds: event.videoIds,
  };
}
